<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">Tools</h1>
  </div>
  <div class="sky-card-body">
    <div class="grid grid-2">
      <a class="container" [routerLink]="['/outfit-request/closet']">
        <mat-icon class="menu-icon">checkroom</mat-icon>
        <span class="menu-label">
          Outfit request closet
        </span>
      </a>
      <a class="container" [routerLink]="['/outfit-request/collage']">
        <mat-icon class="menu-icon">image</mat-icon>
        <span class="menu-label">
          Outfit request collage
        </span>
      </a>
    </div>
  </div>
</div>
